import * as React from "react";
import { pushTrackingEvent } from "~/utils/tracking-utils";
import { INavigationSiteLogoProps } from "../navigation-site-logo/navigation-site-logo";

interface GlobalSiteProps extends INavigationSiteLogoProps {
    logoLinkTarget?: string;
}

export interface NavigationGlobalSitesProps extends GlobalSiteProps {
    richText: string;
    sites: GlobalSiteProps[];
}

const NavigationGlobalSites: React.SFC<NavigationGlobalSitesProps> = props => {
    const baseClass = "navigation-global-sites";

    return (
        <div className={baseClass}>
            <a className={`${baseClass}__logo-link`} href={props.logoLinkUrl} target={props.logoLinkTarget}>
                <img
                    className={`${baseClass}__logo`}
                    src={props.logoSrc}
                    alt={props.logoAlt}
                    loading="lazy"
                />
            </a>
            <div
                className={`${baseClass}__rich-text content-rich-text`}
                dangerouslySetInnerHTML={{ __html: props.richText }}
            />
            <div className={`${baseClass}__site-list-wrapper`}>
                <div className={`${baseClass}__site-list`}>
                    {props.sites.map((site, index) => (
                        <div className={`${baseClass}__site-item`} key={index}>
                            <a
                                className={`${baseClass}__site-link`}
                                href={site.logoLinkUrl}
                                target={site.logoLinkTarget}
                                onClick={() =>
                                    pushTrackingEvent({
                                        event: "trackEvent",
                                        eventData: {
                                            category: "GLOBAL_NAVIGATION",
                                            action: "CLICK",
                                            label: site.logoAlt
                                        }
                                    })
                                }
                            >
                                <img
                                    className={`${baseClass}__logo`}
                                    src={site.logoSrc}
                                    alt={site.logoAlt}
                                    loading="lazy"
                                />
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NavigationGlobalSites;